export default __webpack_public_path__ + "static/media/gallery_07.aafc2848.jpg";